import { InitialTheme, Theme } from '../types';

export const createTheme = (initialTheme: InitialTheme): Theme => ({
  ...initialTheme,
  breakPoints: {
    ...initialTheme.breakPoints,
    down: (key) => `@media (max-width: ${initialTheme.breakPoints.values[key]}) `,
    up: (key) => `@media (width > ${initialTheme.breakPoints.values[key]}) `,
    between: (start, end) =>
      `@media (min-width:${initialTheme.breakPoints.values[start]}) and (max-width:${initialTheme.breakPoints.values[end]}) `,
  },
  spacing: {
    ...initialTheme.spacing,
    calc: (value) => `calc(${initialTheme.spacing.primary} * ${value})`,
  },
});
